import {appAuthApiClient} from "@/api/client";
import {AppAuthUser} from "@/stores/useAuthStore";

export interface SigninParams {
    mobile: string;
    password: string;
}

export const authApi = {
    signin: async (params: SigninParams): Promise<AppAuthUser> => {
        const {data} = await appAuthApiClient.post<AppAuthUser>('/auth/signin', params);
        return data;
    },
    signinByToken: async (token: string): Promise<AppAuthUser> => {
        const {data} = await appAuthApiClient.post<AppAuthUser>('/auth/signinByToken', {token: token});
        return data;
    },
}
